"use client";

import { usePathname } from "next/navigation";
import React from "react";

import NavLink from "@/components/navigation/NavLink";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { NavigationLink } from "@/utils/constants";

interface DesktopNavLinksWrapperProps {
  navigationLinks: NavigationLink[];
}

const DesktopNavLinksWrapper: React.FC<DesktopNavLinksWrapperProps> = ({ navigationLinks }) => {
  const isLargeScreen = useMediaQuery("(min-width: 1280px)");
  const pathname = usePathname();

  if (!isLargeScreen) {
    return null;
  }

  return (
    <>
      {/* Desktop Menu */}
      <div className="hidden xl:flex">
        {navigationLinks
          .filter((link) => link.navBar)
          .map((link, idx) => (
            <NavLink
              key={`desk-${link.href}-${idx}`}
              variant="navbar"
              href={link.href}
              isActive={pathname.startsWith(link.href)}
            >
              {link.name}
            </NavLink>
          ))}
      </div>
    </>
  );
};

export default DesktopNavLinksWrapper;
